import { createContext } from 'react';
import noop from 'lodash/noop';
const TabsContext = createContext({
    changeActiveKey: noop,
    saveCustomized: noop,
    groupedPanelsMap: new Map(),
    currentPanelMap: new Map(),
    totalPanelsMap: new Map(),
});
export default TabsContext;
